import styled from 'styled-components';

import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

export const StyledPackagesMissingEntities = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;

export const StyledPackagesMissingEntitiesContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPackagesMissingEntitiesIcon = styled(AlertWarningIcon)`
  color: ${theme.colors.charcoal700};
`;

export const StyledPackagesMissingEntitiesMessage = styled.span`
  ${{ ...theme.typography.bodySmall }}
  margin-left: 9px;
  color: ${theme.colors.charcoal700};
`;
